module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/usuarios/usuarios-permisos/usuarios-permisos.component.scss
// module id = ./src/app/components/usuarios/usuarios-permisos/usuarios-permisos.component.scss
// module chunks = main